import { SORT_STATE } from '@module/shared/commonTypes';

import { IUserFilterValue, UserFilterValue } from './models';

export interface ISearchState {
  data?: any[];
  showFilter?: boolean;
  totalItemCount?: number;
}

export interface IUserSearchProps {
  filter: IUserFilterValue;
  display: number;
  skip: number;
  sortField: string;
  sortDirection: SORT_STATE;
}

export const initialUserFilterState: IUserSearchProps = {
  filter: new UserFilterValue(),
  display: 15,
  skip: 0,
  sortField: 'email',
  sortDirection: 'asc',
};

export function userSearchReducer(state = initialUserFilterState, action: any): IUserSearchProps {
    switch (action.type) {
      case 'USER_FILTER_UPDATE':
        return { ...state, filter: action.filter, skip: 0 };
      case 'USER_SORT_UPDATE':
        return { ...state, sortField: action.sortField, sortDirection: action.sortDirection };
      case 'USER_PAGING_UPDATE':
        return { ...state, skip: action.skip};
      case 'USER_ROWS_PER_PAGE_UPDATE':
        return { ...state, display: action.display, skip: 0 };
      case 'USER_CLEAR':
      const newFilter = { ...initialUserFilterState.filter, display: state.filter.display };
      return { ...initialUserFilterState, filter: newFilter };
      default:
        return state;
    }
  }
